import getAllNodesInTree from './getAllNodesInTree';

export default function getQuestionBlockNodesTree(node) {
  return getAllNodesInTree(node, 'DIV', { isQuestion: true });
}
